import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import { Button, Input } from "@atomaro/ui-kit";
import { useEffect, useState } from "react";
import { useDictionariesStore } from "entities/dictionaries";
import {
  DictionaryAddContent,
  DictionaryAddFooter,
  DictionaryAddHeaderRow,
  DictionaryAddPopup,
} from "./style";
import { COLORS } from "shared/consts";

export const EditDictionaryNameModal = ({ isMobile }: { isMobile: boolean }) => {
  const {
    isEditModalOpen,
    editOpenId,
    typeHandlerType,
    closeEditModal,
    renameDictionary,
    dictionaries,
  } = useDictionariesStore();

   const dictionary = dictionaries.find((d) => d.id === editOpenId);

  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

 useEffect(() => {
  if (!isEditModalOpen || typeHandlerType !== "dictionaryName") return;
  setValue(dictionary?.type ?? "");
  setError("");
  setSaving(false);
}, [isEditModalOpen, typeHandlerType, dictionary]);

  if (!isEditModalOpen || typeHandlerType !== "dictionaryName") return null;

  const onSave = async () => {
    const trimmed = value.trim();

    if (!trimmed) {
      setError("Введите название");
      return;
    }

    if (!dictionary) return;

    setSaving(true);
    try {
      await renameDictionary(dictionary.type, trimmed);
      closeEditModal();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isEditModalOpen}
      centered
      style={{ padding: 0 }}
      onClickOverlay={closeEditModal}
      maxWidth={isMobile ? "100vw" : "360px"}
      maxHeight={isMobile ? "100vh" : "auto"}
    >
      <DictionaryAddPopup>
        <DictionaryAddHeaderRow>
          <h3>Переименовать словарь</h3>
          <Button
            size="s"
            variant="outline"
            colorScheme="neutral"
            onClick={closeEditModal}
            iconPrefix={
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{ fill: "none" }}
              >
                <rect width="24" height="24" />
                <path
                  d="M10.94 12.0006L5 17.9417L6.06 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L5 6.0595L10.94 12.0006Z"
                  fill={COLORS.FG.DEFAULT}
                />
              </svg>
            }
          />
        </DictionaryAddHeaderRow>

        <DictionaryAddContent>
          <Input
            placeholder="Название словаря"
            name="dictionary-name"
            value={value}
            size="l"
            label="Новое название"
            error={error}
            onChange={(e) => {
              setValue(e.target.value);
              if (error) setError("");
            }}
            disabled={saving}
          />
        </DictionaryAddContent>

        <DictionaryAddFooter isMobile={isMobile}>
          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="neutral"
            variant="ghost"
            label="Отменить"
            style={{ width: "100%" }}
            onClick={closeEditModal}
            disabled={saving}
          />

          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="accent"
            label="Сохранить"
            style={{ width: "100%" }}
            onClick={onSave}
            disabled={saving || !value}
          />
        </DictionaryAddFooter>
      </DictionaryAddPopup>
    </Modal>
  );
};


<svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{ fill: "none" }}
              >
                <rect width="24" height="24" />
                <path
                  d="M10.94 12.0006L5 17.9417L6.06 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L5 6.0595L10.94 12.0006Z"
                  fill={COLORS.FG.DEFAULT}
                />
              </svg>